   /*==========================================================================================================
  FILTERS
  ==========================================================================================================*/
   angular
    .module('vppApp')

    .filter('titleCase', function() {
      return function (input) {
          var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
          var ignoreWords = /^(gm|us|ev?\.?|via)$/i;
          var leaveAlone = /^(OnStar|UAW|Lyriq)$/i;
          if(input){
              input = input.toLowerCase();
               return input.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
                if (index > 0 && index + match.length !== title.length &&
                    match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" &&
                    (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
                    title.charAt(index - 1).search(/[^\s-]/) < 0) {
                    return match.toLowerCase();
                }

                if (match.substr(1).search(/[A-Z]|\../) > -1) {
                    return match;
                }
                if(match.search(ignoreWords) > -1){
                  return match.toUpperCase();
                }
                if(match.search(leaveAlone) > -1){
                  if (match === 'uaw') return 'UAW';
                  else if (match === 'onstar') return 'OnStar';
                  else if (match === 'lyriq') return 'LYRIQ';
                  return match;
                }

                return match.charAt(0).toUpperCase() + match.substr(1);
            });
          }
      };
  });